const MONTH_LABELS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const demoFreightReference = (id) => {
    const year = new Date().getFullYear();
    return `FR-${year}-${String(id).padStart(4, '0')}`;
};

export const shiftDemoDate = ({
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
} = {}) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    date.setHours(hours, minutes, seconds, 0);
    return date;
};

export const addDemoMinutes = (date, minutes) => {
    const next = new Date(date);
    next.setMinutes(next.getMinutes() + minutes);
    return next;
};

export const addDemoDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
};

export const formatDemoIsoDate = (date) => date.toISOString().split('T')[0];

export const formatDemoDateTime = (date) => {
    const month = MONTH_LABELS[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${month} ${day}, ${year} · ${hours}:${minutes}`;
};

export const formatDemoDisplayDate = (date) => {
    const month = MONTH_LABELS[date.getMonth()];
    return `${month} ${date.getDate()}, ${date.getFullYear()}`;
};

export const parseDemoDateTime = (value) => {
    if (!value) {
        return shiftDemoDate();
    }

    const normalizedValue = String(value).trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalizedValue)) {
        const [year, month, day] = normalizedValue.split('-').map(Number);
        return new Date(year, month - 1, day, 9, 0, 0, 0);
    }

    const [datePart, timePart = '09:00'] = normalizedValue.split('·').map((part) => part.trim());
    const [monthLabel, day, year] = datePart.replace(',', '').split(' ');
    const monthIndex = MONTH_LABELS.indexOf(monthLabel);
    const [hours, minutes] = timePart.split(':').map(Number);

    if (monthIndex < 0) {
        return shiftDemoDate();
    }

    return new Date(
        Number(year),
        monthIndex,
        Number(day),
        hours || 0,
        minutes || 0,
        0,
        0
    );
};

export const DEMO_VERIFICATION_ANALYSTS = [
    { name: 'Elena Müller', initials: 'EM' },
    { name: 'James Chen', initials: 'JC' },
    { name: 'Sofia Martinez', initials: 'SM' },
    { name: 'Thomas Weber', initials: 'TW' },
    { name: 'Anna Kowalski', initials: 'AK' },
    { name: 'Lucas Bernard', initials: 'LB' },
    { name: 'Maria Rossi', initials: 'MR' },
    { name: 'Noah Jensen', initials: 'NJ' },
];
